import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Building2, Users as UsersIcon, Home, Briefcase, Scale, FileText } from 'lucide-react';

const Services = () => {
  const { t, direction } = useLanguage();

  const services = [
    {
      icon: Building2,
      title: t('service1Title'),
      description: t('service1Desc'),
      gradient: 'from-amber-400 to-amber-600'
    },
    {
      icon: Scale,
      title: t('service2Title'),
      description: t('service2Desc'),
      gradient: 'from-amber-500 to-orange-500'
    },
    {
      icon: UsersIcon,
      title: t('service3Title'),
      description: t('service3Desc'),
      gradient: 'from-amber-400 to-amber-600'
    },
    {
      icon: Home,
      title: t('service4Title'),
      description: t('service4Desc'),
      gradient: 'from-amber-500 to-orange-500'
    },
    {
      icon: Briefcase,
      title: t('service5Title'),
      description: t('service5Desc'),
      gradient: 'from-amber-400 to-amber-600'
    },
    {
      icon: FileText,
      title: t('service6Title'),
      description: t('service6Desc'),
      gradient: 'from-amber-500 to-orange-500'
    }
  ];

  return (
    <section id="services" className="relative py-24 bg-gradient-to-b from-amber-50/50 to-white overflow-hidden">
      {/* Background decorations */}
      <div className="absolute top-1/4 left-0 w-96 h-96 bg-amber-100/40 rounded-full blur-3xl" />
      <div className="absolute bottom-1/4 right-0 w-96 h-96 bg-amber-100/40 rounded-full blur-3xl" />

      <div className="w-full px-4 relative z-10 max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="inline-block mb-4">
            <span className="px-4 py-2 bg-amber-100 border border-amber-300 rounded-full text-amber-700 text-sm font-medium">
              {t('services')}
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6">
            {t('servicesTitle')}
          </h2>
          <p className="text-lg text-slate-600">
            {t('servicesSubtitle')}
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3 lg:gap-6">
          {services.map((service, index) => {
            const Icon = service.icon;
            return (
              <div
                key={index}
                className="group relative bg-white border-2 border-amber-200 rounded-2xl p-4 md:p-8 hover:border-amber-400 transition-all duration-500 hover:shadow-2xl hover:shadow-amber-500/20 hover:-translate-y-2"
              >
                {/* Icon */}
                <div className="relative mb-4 md:mb-6 flex justify-center">
                  <div className="absolute inset-0 bg-amber-200/40 rounded-xl blur-xl group-hover:blur-2xl transition-all" />
                  <div className={`relative w-12 h-12 md:w-16 md:h-16 rounded-xl bg-gradient-to-br ${service.gradient} flex items-center justify-center shadow-lg transform group-hover:scale-110 transition-transform duration-300`}>
                    <Icon className="w-6 h-6 md:w-8 md:h-8 text-white" />
                  </div>
                </div>

                {/* Content */}
                <h3 className="text-base md:text-xl font-bold text-slate-900 mb-2 md:mb-3 group-hover:text-amber-600 transition-colors text-center leading-tight">
                  {service.title}
                </h3>
                <p className="text-slate-600 leading-relaxed text-sm md:text-base text-center">
                  {service.description}
                </p>

                {/* Decorative element */}
                <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-amber-500 to-transparent opacity-0 group-hover:opacity-100 transition-opacity rounded-b-2xl" />
              </div>
            );
          })}
        </div>

        {/* Bottom CTA */}
        <div className="mt-16 text-center">
          <p className="text-slate-600 mb-6 text-lg" dir={direction === 'rtl' ? 'rtl' : 'ltr'}>
            {direction === 'rtl' 
              ? 'هل تحتاج إلى استشارة قانونية متخصصة؟' 
              : 'Need specialized legal consultation?'}
          </p>
          <button
            onClick={() => {
              const element = document.getElementById('contact');
              if (element) element.scrollIntoView({ behavior: 'smooth' });
            }}
            className="px-8 py-4 bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-600 hover:to-amber-700 text-white font-semibold rounded-lg shadow-lg shadow-amber-500/30 transition-all duration-300 hover:scale-105 hover:shadow-xl hover:shadow-amber-500/40"
          >
            {t('heroButton')}
          </button>
        </div>
      </div>
    </section>
  );
};

export default Services;
